import { useUser } from '../../../redux/reducer/user';
import useFindAchievementById from './useFindAchievementById';

export const useActivePremiumAchievementIcon = (props = {}) => {
  const {
    profile: { iconId },
  } = useUser();

  const getAchievementById = useFindAchievementById();
  const necessaryIcon = props.hasOwnProperty('extraPremiumIcon') ? props.extraPremiumIcon : iconId;
  return getAchievementById(necessaryIcon)?.icon;
};
